import React, { Component } from 'react'

class HomeContainer extends Component {
	render() {
		return (
			<div>
				Pantalla de inicio
			</div>
		)
	}
}

export default HomeContainer
